module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (22).5613474f.jpg";